import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=3ffb38a1&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=3ffb38a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb38a1",
  null
  
)

export default component.exports